const mediaItems = [
  {
    title: '《凤隐天下》终极预告',
    desc: '权谋天下，一曲倾城——年度古装巨制',
    duration: '02:35',
    views: '1280万',
    image: 'https://readdy.ai/api/search-image?query=epic%20Chinese%20costume%20drama%20trailer%20scene%2C%20grand%20palace%20battle%2C%20flowing%20silk%20robes%2C%20dramatic%20lighting%20with%20sunbeams%20through%20ancient%20windows%2C%20emotional%20close-up%20of%20elegant%20character%2C%20cinematic%20widescreen%20composition&width=800&height=450&seq=media-01-2026&orientation=landscape',
  },
  {
    title: '《镜像追踪》高能片段合集',
    desc: '十大反转名场面，每一帧都细思极恐',
    duration: '05:12',
    views: '960万',
    image: 'https://readdy.ai/api/search-image?query=intense%20Korean%20thriller%20scene%2C%20detective%20examining%20evidence%20in%20dark%20room%20with%20single%20hanging%20light%2C%20tense%20expression%2C%20crime%20board%20with%20photos%20and%20strings%2C%20noir%20atmosphere%2C%20dramatic%20shadows&width=800&height=450&seq=media-02-2026&orientation=landscape',
  },
  {
    title: '《山海秘境》幕后花絮',
    desc: '三年制作历程，国漫匠人的极致追求',
    duration: '08:40',
    views: '750万',
    image: 'https://readdy.ai/api/search-image?query=animation%20studio%20behind%20the%20scenes%2C%20artists%20working%20on%20digital%20tablets%20with%20character%20designs%20on%20large%20screens%2C%20colorful%20concept%20art%20on%20walls%2C%20creative%20workspace%20with%20warm%20ambient%20lighting%2C%20inspiring%20atmosphere&width=800&height=450&seq=media-03-2026&orientation=landscape',
  },
  {
    title: '每周观影指南：7月新片速递',
    desc: '十部暑期档必看佳片，一网打尽',
    duration: '12:18',
    views: '620万',
    image: 'https://readdy.ai/api/search-image?query=colorful%20movie%20poster%20collage%20wall%20in%20modern%20living%20room%2C%20warm%20ambient%20lighting%2C%20film%20reel%20decorations%2C%20cinema%20aesthetic%2C%20cozy%20atmosphere%20with%20string%20lights%2C%20creative%20composition&width=800&height=450&seq=media-04-2026&orientation=landscape',
  },
  {
    title: '《面包和汤和猫咪》治愈混剪',
    desc: '一个人的三餐四季，温暖每一颗疲惫的心',
    duration: '04:05',
    views: '890万',
    image: 'https://readdy.ai/api/search-image?query=cozy%20Japanese%20kitchen%20with%20steaming%20soup%20pot%20on%20stove%2C%20cat%20sitting%20on%20window%20sill%20with%20sunlight%2C%20fresh%20herbs%20and%20vegetables%20on%20wooden%20table%2C%20soft%20natural%20lighting%2C%20warm%20minimalist%20aesthetic%2C%20peaceful%20domestic%20scene&width=800&height=450&seq=media-05-2026&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          精彩速递
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-[480px] mx-auto">
          预告片、花絮、混剪——一站式浏览影视精彩瞬间
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.slice(0, 3).map((item) => (
            <article
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden h-[220px]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 bg-black/60 text-background-50 text-[10px] rounded-md">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 line-clamp-1 mb-1">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between">
                  <p className="text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
                  <span className="text-[10px] text-foreground-400 whitespace-nowrap ml-2 flex items-center gap-1">
                    <i className="ri-eye-line text-xs"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {mediaItems.slice(3).map((item) => (
            <article
              key={item.title}
              className="group flex flex-col sm:flex-row bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden w-full sm:w-[240px] h-[160px] sm:h-auto flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-lg ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/60 text-background-50 text-[10px] rounded-md">
                  {item.duration}
                </span>
              </div>
              <div className="flex-1 p-4 flex flex-col justify-center">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                <span className="text-[10px] text-foreground-400 mt-2 flex items-center gap-1">
                  <i className="ri-eye-line text-xs"></i>
                  {item.views} 次观看
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}